import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/google-drive'

export const getGoogleFileInfo = async (url) => {
    const { data } = await axios.post(`${baseURL}/file-info`, { url }, getAuthHeader())
    return data
}

export const downloadGoogleFile = async (fileId, fileName) => {
    const { data } = await axios.get(`${baseURL}/download/${fileId}`, {
        ...getAuthHeader(),
        responseType: 'blob'
    })

    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
}

export const generateLocalPreview = async (path, name) => {
    const { data } = await axios.post(`${baseURL}/preview-local`, { path, name }, getAuthHeader())
    return data
}
